import { applicantHistoryRequests } from "@/src/api/applicantHistoryRequests";
import { applicantsRequests } from "@/src/api/applicantsRequests";
import { IRowData } from "@/src/types/applicationOnline";
import { mapApplicantHistoryItems } from "./mapApplicantHistory";
import { mapApplicantToUserInfo } from "./mapApplicantToUserInfo";

export const fetchApplicantUserInfo = async (applicantId: number): Promise<IRowData["userInfo"] | undefined> => {
  const applicant = await applicantsRequests.getById(applicantId);
  if (!applicant) return undefined;

  const userInfo = mapApplicantToUserInfo(applicant);
  const history = await applicantHistoryRequests.getByApplicantId(applicantId);
  if (history) {
    userInfo.history = mapApplicantHistoryItems(history, applicantId);
  }

  return userInfo;
};
